import React from 'react';
import { makeStyles, tokens, Text, Button, Subtitle1, Divider } from '@fluentui/react-components';

const useStyles = makeStyles({
  buttonContainer: {
    marginTop: tokens.spacingVerticalM,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '100%',
  
  },
  emergencyText: {
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground3,
    fontStyle: 'italic',
  },
});

interface CoachingSessionSectionProps {
  coachingUrl?: string;
}

export const CoachingSessionSection: React.FC<CoachingSessionSectionProps> = ({ coachingUrl }) => {
  const styles = useStyles();
  const coachingText1 = `Get personalised support from one of Groov's professional coaches — experienced specialists with backgrounds across behavioural science, leadership, organisational psychology and human performance.`;
  const coachingText2 = `They can help you navigate workplace challenges more effectively, strengthen key skills, and create clear action plans for your professional and personal development.`;
  const coachingText3 = `Each session is practical, focused, and confidential, built entirely around what matters most to you.`;

  const emergencyText = `If you are in distress or need to talk to someone about your mental wellbeing, call or text 1737.`;


  return (
    <>
      <Subtitle1 style={{ marginTop: 15 }}>Book a 1:1 Coaching Session</Subtitle1>
      <Text style={{whiteSpace: 'pre-line' }}>
        {coachingText1}
      </Text>
      <Text style={{whiteSpace: 'pre-line' }}>
        {coachingText2}
      </Text>
      <Text style={{whiteSpace: 'pre-line' }}>
        {coachingText3}
        <div className={styles.buttonContainer}>
          <Button
            appearance="primary"
            as="a"
            href={coachingUrl}
            target="_blank"
            rel="noreferrer"
          >
            Book a session
          </Button>
        </div>
      </Text>
      <Text className={styles.emergencyText}>{emergencyText}</Text>
      <br/>
      <Divider />
    </>
  );
};

